import style from "../css/Rewards.module.css";
import fpCoin from "../../../icons/coin.svg";

const FanduPointsToast = ({ points = 10, onClose, visible = true }) => {
  if (!visible) return null;

  return (
    <div className={style.toastWrapper}>
      <div className={style.toast}>
        <img src={fpCoin} alt="Fandu Points" className={style.coin} />

        <div className={style.content}>
          <p className={style.title}>Congratulations You have Earned</p>

          <p className={style.points}>{points} Fandu Points 🎉</p>
        </div>

        <button className={style.closeBtn} onClick={onClose}>
          ✕
        </button>
      </div>

      <div className={style.bottomStrip} />
    </div>
  );
};

export default FanduPointsToast;
